export const getFilterMatchForQuery = (searchQuery, filterRegex) => {
  const regex = new RegExp(filterRegex)

  return regex.exec(searchQuery)
}
